import React from "react";
var __jsx = React.createElement;
import { usePostDetails } from "@/common/Contexts/PostDetailsContext";
import stl from "./PaymentTabBoxPopup.module.css";
import BottomSheetPopup from "@componentsShared/BottomSheetPopup__OLD/BottomSheetPopup";
import { useTranslation } from "@i18n";
import SAR from "@componentsShared/SAR/SAR";
var PaymentTabBoxPopup = function PaymentTabBoxPopup(_ref) {
  var _priceSection$finance, _priceSection$finance2, _priceSection$finance3, _priceSection$finance4;
  var onClose = _ref.onClose;
  var _usePostDetails = usePostDetails(),
    postDetails = _usePostDetails.postDetails,
    helpers = _usePostDetails.helpers;
  var priceSection = postDetails.price;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BottomSheetPopup, {
    show: true,
    onClose: onClose,
    className: stl.customPopUp
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.kastDetails
  }, /*#__PURE__*/React.createElement("strong", null, t("financing_details", {
    ns: "web_post_view"
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.kastInfo2
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.kastRowHeading
  }, /*#__PURE__*/React.createElement("span", null, t("installment_starts", {
    ns: "web_post_view"
  })), /*#__PURE__*/React.createElement("strong", null, priceSection === null || priceSection === void 0 ? void 0 : (_priceSection$finance = priceSection.finance_price) === null || _priceSection$finance === void 0 ? void 0 : _priceSection$finance.text, /*#__PURE__*/React.createElement("span", null, t("sar_month", {
    ns: "web_post_view"
  })))), /*#__PURE__*/React.createElement("div", {
    className: stl.kastRow
  }, /*#__PURE__*/React.createElement("span", null, t("installment_duration", {
    ns: "web_post_view"
  })), /*#__PURE__*/React.createElement("strong", null, priceSection === null || priceSection === void 0 ? void 0 : (_priceSection$finance2 = priceSection.finance_price) === null || _priceSection$finance2 === void 0 ? void 0 : _priceSection$finance2.installment_period, /*#__PURE__*/React.createElement("span", null, t("month", {
    ns: "web_post_view"
  })))), /*#__PURE__*/React.createElement("div", {
    className: stl.kastRow
  }, /*#__PURE__*/React.createElement("span", null, t("down_payment", {
    ns: "web_post_view"
  })), /*#__PURE__*/React.createElement("strong", null, priceSection === null || priceSection === void 0 ? void 0 : (_priceSection$finance3 = priceSection.finance_price) === null || _priceSection$finance3 === void 0 ? void 0 : _priceSection$finance3.first_payment, /*#__PURE__*/React.createElement("span", {
    className: "text-2xl"
  }, /*#__PURE__*/React.createElement(SAR, null)))), /*#__PURE__*/React.createElement("div", {
    className: stl.kastRow
  }, /*#__PURE__*/React.createElement("span", null, t("last_payment", {
    ns: "web_post_view"
  })), /*#__PURE__*/React.createElement("strong", null, priceSection === null || priceSection === void 0 ? void 0 : (_priceSection$finance4 = priceSection.finance_price) === null || _priceSection$finance4 === void 0 ? void 0 : _priceSection$finance4.last_payment, /*#__PURE__*/React.createElement("span", {
    className: "text-2xl"
  }, /*#__PURE__*/React.createElement(SAR, null))))), /*#__PURE__*/React.createElement("p", {
    className: stl.NewKastNot
  }, helpers.isCarUsed() ? t("estimated_monthly_payment_comprehensive_insurance_2", {
    ns: "web_post_view"
  }) : t("estimated_monthly_payment_comprehensive_insurance", {
    ns: "web_post_view"
  })))));
};
export default PaymentTabBoxPopup;